// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__UmiBu","emails":"CreateEditClinics_emails__k4tNT","emailTagLabel":"CreateEditClinics_emailTagLabel__3iFYk"};